/*!
* Scroll to js
*/

const scrollElem = '.scrollTo';
const duration = 800;
const timeOutBeforeScroll = 1000;
const wrapMenu = '.header-mobile__menu';
const closeElem = '#offCanvas';
const offsetTop = -72;

/**
 * Init subscribe form
 */
let init = () => {
    $('body').on('click', scrollElem, (e) => {
        e.preventDefault();
        let $target = $(e.currentTarget);
        let anchor = $target.attr('href');
        let $parentMenu = $target.closest(wrapMenu);

        if ($parentMenu.length) {
            new Promise((resolve) => {
                $(closeElem).foundation('close');
                setTimeout(() => {
                    resolve();
                }, timeOutBeforeScroll);
            }).then(() => {
                $.scrollTo(anchor, duration, {offset: offsetTop});
            });
        } else {
            $.scrollTo(anchor, duration, {offset: offsetTop});
        }
    });
};

export {init as initScrollTo};
